import { Box, Typography } from '@mui/material';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';
export const Isolation = ({ model, isolation }) => {
    const { t } = useTranslation();
    const isolationInfo = t(`${model}.isolation`);
    const info =
        isolationInfo.localeCompare(`${model}.isolation`) === 0 || isolationInfo === undefined
            ? isolation
            : isolationInfo;
    return (
        <Box>
            <Typography>
                <span className={typography.modelDescriptionSubTitle}>
                    {t('model.isolation')}:{' '}
                </span>
                <span className={typography.modelDescription}> {info} </span>
            </Typography>
        </Box>
    );
};
